import classNames from 'classnames';
import React from 'react';
import styles from './NotificationCategoryIcon.module.scss';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  color: string;
  icon?: JSX.Element;
  size: 'xsmall' | 'small' | 'medium' | 'large';
}

const NotificationCategoryIcon: React.FC<Props> = ({
  className,
  color,
  icon,
  size,
  style,
  ...rest
}) => {
  if (!icon) {
    return null;
  }
  const containerClass = classNames(styles.container, styles[`size-${size}`], className);
  const containerStyle = { ...style, backgroundColor: color };
  return (
    <div className={containerClass} style={containerStyle} {...rest}>
      {icon}
    </div>
  );
};

export default NotificationCategoryIcon;
